import { render, staticRenderFns } from "./Results.vue?vue&type=template&id=4b69d632&scoped=true&"
import script from "./Results.js?vue&type=script&lang=js&"
export * from "./Results.js?vue&type=script&lang=js&"
import style0 from "./Results.scss?vue&type=style&index=0&id=4b69d632&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b69d632",
  null
  
)

export default component.exports